export enum TagType {
  Watterfall = "Waterfall",
  Castle = "Castle",
  Park = "Park",
  Lake = "Lake",
  MountainPass = "Mountain pass",
}

export enum AvoidType {
  MOTORWAY = "MOTORWAY",
  FERRY = "FERRY",
  BRIDGE = "BRIDGE",
  TUNNEL = "TUNNEL",
  TOLL = "TOLL",
}

export enum GraphhopperBillingType {
  Standard = "Standard",
  Free = "Free",
}

export enum DurationType {
  "weekend-ride" = "weekend-ride",
  "week-off" = "week-off",
  journey = "journey",
  adventure = "adventure",
}

export enum GraphhopperErrorStatus {
  Unknown = 0,
  MinutelyLimit = 429,
}

export enum RoadType {
  calm = "calm",
  twisty = "twisty",
}

export enum RouteBuildVariant {
  linear = "linear",
  radius = "radius",
}

export const DurationRange = {
  [DurationType["weekend-ride"]]: [1, 2] as [number, number],
  [DurationType["week-off"]]: [3, 5] as [number, number],
  [DurationType.journey]: [6, 15] as [number, number],
  [DurationType.adventure]: [16, 30] as [number, number],
};

export enum DurationKey {
  "1-2 days" = "1-2 days",
  "3-5 days" = "3-5 days",
  "6-15 days" = "6-15 days",
  "16-30 days" = "16-30 days",
}

export enum Regions {
  West = "West",
  East = "East",
  North = "North",
  South = "South",
  Middle = "Middle",
}

export enum GraphhopperKeyGroup {
  Routing = "Routing",
  ParsingMiddleEurope = "ParsingMiddleEurope",
  ParsingEastEurope = "ParsingEastEurope",
  ParsingSouthEurope = "ParsingSouthEurope",
  ParsingNorthEurope = "ParsingNorthEurope",
  ParsingWestEurope = "ParsingWestEurope",
}
